import { __rest } from 'tslib';
import { jsxs, jsx } from 'react/jsx-runtime';
import classNames from 'classnames';

var FilesIllustration = function FilesIllustration(_a) {
  var className = _a.className,
    _a$color = _a.color,
    color = _a$color === undefined ? 'sapphire' : _a$color,
    otherProps = __rest(_a, ["className", "color"]);
  return jsxs("svg", Object.assign({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "aria-label": "FilesIllustration",
    role: "img",
    viewBox: "0 0 112 72",
    xmlns: "http://www.w3.org/2000/svg",
    width: "112",
    height: "72",
    fill: "none",
    className: classNames('cogs-illustration', 'cogs-themed-icon', className)
  }, otherProps, {
    children: [jsxs("g", {
      fill: "var(--cogs-decorative--".concat(color, "--400)"),
      clipPath: "url(#clip0_404_26815)",
      children: [jsx("path", {
        d: "m59.785 29.818-8.716-15.096L27.847 8.5 4.464 22A4 4 0 0 0 3 27.464l24 41.57a4 4 0 0 0 5.464 1.463l27.32-15.773 27.321 15.773a4 4 0 0 0 5.464-1.464l17.5-30.31-6.222-23.223L80.464 2A4 4 0 0 0 75 3.464z",
        opacity: ".3"
      }), jsx("path", {
        d: "m39.81 21.222 11.26-6.5L27.846 8.5l6.5 11.258a4 4 0 0 0 5.464 1.464M98.81 32.222l11.259 6.5-6.222-23.222-6.5 11.258a4 4 0 0 0 1.464 5.464",
        opacity: ".15"
      }), jsx("path", {
        d: "M39.785 56.249h40a4 4 0 0 0 4-4V18.077a2 2 0 0 0-.586-1.414L67.371.834A2 2 0 0 0 65.957.25H39.785a4 4 0 0 0-4 4v48a4 4 0 0 0 4 4",
        opacity: ".5"
      }), jsx("path", {
        d: "M70.785 17.249h13l-17-17v13a4 4 0 0 0 4 4",
        opacity: ".4"
      })]
    }), jsx("defs", {
      children: jsx("clipPath", {
        id: "clip0_404_26815",
        children: jsx("path", {
          fill: "#fff",
          d: "M0 0h112v72H0z"
        })
      })
    })]
  }));
};

export { FilesIllustration };
